// extracted by mini-css-extract-plugin
export var cartIcon = "_gv-0";
export var cartIconContainer = "_gv-1";